import { EventObject, trackEvent } from "@proj-client/analytics/analytics"
import { ContentBlockHero } from "@proj-client/components/landing/content-block-hero"
import { ContentBlockValueProp } from "@proj-client/components/landing/content-block-value-prop"
import { FeatureList } from "@proj-client/components/landing/feature-list"
import { NavBar } from "@proj-client/components/navbar"
import { IFeature } from "@proj-common/types"
import { useEffect, useState } from "react"
import IdeateLive1Img from "@proj-client/assets/imgs/landing/ideatelive1.png"
import IdeateLive2Img from "@proj-client/assets/imgs/landing/ideatelive2.png"
import IdeateLive3Img from "@proj-client/assets/imgs/landing/ideatelive3.png"
import { ContentBlockHighlight } from "@proj-client/components/landing/content-block-highlight"
import { FooterGeneric } from "@proj-client/components/footer-generic"

import { ComparePlans, getDefaultPlanLookupKey } from "@proj-client/components/generic/plans"
import { useUserDataStore } from "@proj-client/stores/userDataStore"
import { ColorEmoteBackground, EmoteBgPosition } from "@proj-client/components/landing/colorEmoteBackground"

import { ContentFeatures } from "@proj-client/components/landing/content-block-features"
import { get } from "lodash"
import { ContentBlock } from "@proj-client/components/landing/contentBlock"

import LogoBlackbirdImg from "@proj-client/assets/imgs/landing/logoBlackbird.svg"
import LogoAbilityMatrixImg from "@proj-client/assets/imgs/landing/logoAbilityMatrix.svg"
import LogoWhy from "@proj-client/assets/imgs/landing/logoWhy.svg"


export const LandingPage = (props) => {

    const userData = useUserDataStore()

    const [hamburgerItems, setHamburgerItems] = useState([])
    const [mainItems, setMainItems] = useState([])
    const [userMenu, setUserMenu] = useState(false)

    const signUpCTA = "Book a demo"
    const singnUpCTANav = "Sign up"

    const bookDemo = () => {
        window.open("https://calendly.com/szakacsszilard", "_blank")
    }

    const subscribeToPlan = (subscriptionLookupKey?: string) => {
        let lookupKey = subscriptionLookupKey || getDefaultPlanLookupKey()

        if (subscriptionLookupKey) {
            window.location.href = '/register?lookupKey=' + lookupKey
        }
        else {
            window.location.href = "/register"
        }
    }

    const onSignup = (subscriptionLookupKey?: string) => {
        bookDemo()

        trackEvent(new EventObject(EventObject.Action.SignupStarted, null, null, null))
    }

    useEffect(() => {
        if (userData?.user_type == 'registered' || userData?.user_type == 'participant') {
            setUserMenu(true)
        }
        if (userData?.user_type != 'registered') {
            setHamburgerItems([
                {
                    url: '/login',
                    text: 'Login',
                    accent: 'idtn-btn-secondary'
                },
                {
                    clickHandler: onSignup,
                    text: singnUpCTANav,
                    accent: 'idtn-btn-primary'
                }])
        } else {
            setHamburgerItems([
                {
                    url: '/events',
                    text: 'Dashboard',
                    accent: 'idtn-btn-primary'
                }
            ])
        }
        setMainItems([
            {
                url: '/join',
                text: 'Join Event',
                accent: 'idtn-btn-secondary'
            }
        ])

        return () => {
            setHamburgerItems([])
            setMainItems([])
        }
    }, [userData])



    return (
        // https://tailwindui.com/components/marketing/sections/heroes
        <div className="relative bg-slate-50 overflow-x-hidden">
            <ColorEmoteBackground position={EmoteBgPosition.top} />
            <ColorEmoteBackground position={EmoteBgPosition.bottom} />

            <div className="relative overflow-hidden  ">
                {
                    // NAV
                }
                <div className="relative z-10">
                    <NavBar
                        fullWidth={false}
                        hamburgerItems={hamburgerItems}
                        mainItems={mainItems}
                        userMenu={userMenu}
                        hasBorder={false}
                        isSticky={true}
                    />
                </div>

                {
                    // Content
                    // mx-auto max-w-7xl
                }
                <div >
                    <ContentBlockHero
                        ctaHandler={onSignup}
                        ctaText={signUpCTA}
                    />

                    <div className='mb-[17vh] md:mb-[8vh]'></div>

                    {
                        // Logos
                    }
                    <ContentBlock>
                        <div className="h-6 md:h-10 flex flex-row md:space-x-16 space-x-8" aria-label="Happy Customers">
                            <LogoBlackbirdImg aria-label="BlackBird.io" />
                            <LogoWhy aria-label="" />
                            <LogoAbilityMatrixImg aria-label="Ability Matrix" />
                        </div>
                    </ContentBlock>

                    <div className='mb-[17vh] md:mb-[8vh]'></div>

                    <ContentFeatures
                        ctaHandler={onSignup}
                        ctaText={signUpCTA}
                    />

                    {/*<ComparePlans selectedPlanCB={onSignup} />*/}
                    { /* 
                    
                    TODO: further content here 

                    <ContentBlock bgColor={"bg-slate-100"}>
                        <div className="flex flex-col items-center">
                            <div className="flex flex-row justify-center flex-1 p-2">
                                <div className="flex flex-col max-w-sm text-center">
                                    <h1 className="text-[1.7rem] font-bold md:text-3xl font-display leading-tight">
                                        Don't just take our word for it..
                                    </h1>
                                </div>
                            </div>
                            <div className="mt-4 md:hidden">
                                social proof
                                {
                                    // Mobile view
                                }
                            </div>
                            <div className="hidden gap-4 md:grid md:grid-cols-2 lg:grid-cols-3 md:pt-4 md:pb-4" >
                                social proof
                                {
                                    // Desktop view
                                }
                            </div>
                            <div className="flex flex-row justify-center flex-1 p-2">
                                <div className="flex flex-col max-w-sm text-center">
                                    <h1 className="text-[1.7rem] font-bold md:text-3xl font-display leading-tight">
                                        The digitally native brainstorming platform
                                    </h1>
                                </div>
                            </div>
                            <a href="/new"
                                //TODO: onClick={this.props.ctaHandler && this.props.ctaHandler()}
                                className="mt-8 mb-8 umami--click--get-started idtn-btn-primary-xl place-self-center"
                            >
                                Get Started
                            </a>
                        </div>
                    </ContentBlock>

                            */
                    }

                    <FooterGeneric />



                </div>
            </div>


        </div>
    )
}